import type { CheckboxProps } from './const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import './index.less';

function Checkbox(props: CheckboxProps, ref: React.Ref<HTMLDivElement>) {
  const { checked, onChange, className, style, disabled, noTransition } = props;

  const handleClick = () => {
    if (disabled) {
      return;
    }
    onChange?.(!checked);
  };

  return (
    <div
      ref={ref}
      className={cn(
        'wg-checkbox',
        {
          'wg-checkbox--checked': checked,
          'wg-checkbox--disabled': disabled,
          'wg-checkbox--no-transition': noTransition,
        },
        className,
      )}
      style={style}
      onClick={handleClick}
    >
      <svg fill="none" viewBox="0 0 15 14" width="10" height="9.3">
        <path d="M2 8.36364L6.23077 12L13 2"></path>
      </svg>
    </div>
  );
}

const CheckboxComponent = forwardRef<HTMLDivElement, CheckboxProps>(Checkbox);
CheckboxComponent.displayName = 'Checkbox';

export default CheckboxComponent;

export type { CheckboxProps };
